// src/components/SubscriptionCanceled/SubscriptionCanceledMobile.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import MobileHeader from "./headers/MobileHearder";

export default function SubscriptionCanceledMobile() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log(
      "ℹ️ User arrived on subscription canceled (mobile):",
      currentUser?.uid
    );
  }, [currentUser]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <MobileHeader
          title={translate("SubscriptionCanceledTitle")}
          showProfileItem={false}
        />
      </Box>

      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <PauseCircleOutlineIcon
          sx={{ fontSize: 72, color: "warning.main", mb: 2 }}
        />
        <Typography variant="h5" gutterBottom>
          {translate("SubscriptionCanceledTitle")}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ mb: 3, color: "text.secondary" }}
        >
          {translate("SubscriptionCanceledMessage")}
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/app/gotopremium")}
        >
          {translate("RenewSubscription")}
        </Button>
      </Box>
    </Box>
  );
}
